import { getWindowOrigin } from '#pplx/frontend/common/location.js';
const PUBLIC_WEB_ORIGIN_FALLBACK = 'https://www.perplexity.ai';
const unescapeMarkdownLinkTarget = (value) => value.replace(/\\([\\()"])/g, '$1');
function normalizeAllowedOrigin(origin) {
    try {
        return new URL(origin).origin;
    }
    catch {
        return null;
    }
}
function getAllowedOrigins() {
    const origins = [
        PUBLIC_WEB_ORIGIN_FALLBACK,
        getWindowOrigin({ intent: 'public-web' }),
        getWindowOrigin({ intent: 'document' }),
    ];
    return new Set(origins.flatMap((origin) => {
        const normalizedOrigin = origin && normalizeAllowedOrigin(origin);
        return normalizedOrigin ? [normalizedOrigin] : [];
    }));
}
export function getMentionUrlParseBase() {
    return getWindowOrigin({ intent: 'public-web' }) || PUBLIC_WEB_ORIGIN_FALLBACK;
}
/** Parses a markdown link target into a URL on an origin this app serves, or null. */
export function parseOwnedMentionUrl(rawUrl) {
    const href = unescapeMarkdownLinkTarget(rawUrl.trim().split(/\s+/, 1)[0] ?? '');
    if (!href)
        return null;
    let url;
    try {
        url = new URL(href, getMentionUrlParseBase());
    }
    catch {
        return null;
    }
    return getAllowedOrigins().has(url.origin) ? url : null;
}
//# sourceMappingURL=mentionLinkUrl.js.map